<div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="election-union" class="p-30">
  <div class="flex align-items-center content-between" style="grid-column: 1 / -1;">
    <div class="flex gap-10 align-items-center">
      <img src="assets/profile-blue-icon.svg" alt="">
      <h3 class="dark-blue no-margin">Organisation syndicale {{index + 1}}</h3>
    </div>
    <img src="assets/trash-red-icon.svg" class="pointer" alt="" (click)="removeAt(index)">
  </div>
  <div style="grid-column: 1 / -1;">
    <p class="dark-blue no-margin">Nom de l'organisation</p>
    <input [(ngModel)]="union.unionName" (ngModelChange)="onUnionChange()" type="text" name="unionName" id="unionName"
      class="w-full text-md dark-blue pap-input" value="{{union.unionName}}" placeholder="CGT, CFDT, FO, UNSA...">
  </div>

  <div>
    <p class="dark-blue no-margin">Civilité</p>
    <div class="flex gap-10">
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="radio" [name]="'gender-' + index" [value]="true" [(ngModel)]="union.man"> Monsieur
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="radio" [name]="'gender-' + index" [value]="false" [(ngModel)]="union.man"> Madame
      </label>
    </div>
  </div>

  <div></div>

  <div>
    <p class="dark-blue no-margin">Prénom du représentant</p>
    <input [(ngModel)]="union.firstName" (ngModelChange)="onUnionChange()" type="text" name="firstName" id="firstName"
      class="w-full text-md dark-blue pap-input" value="{{union.firstName}}">
  </div>

  <div>
    <p class="dark-blue no-margin">Nom du représentant</p>
    <input [(ngModel)]="union.lastName" (ngModelChange)="onUnionChange()" type="text" name="lastName"
      class="w-full text-md dark-blue pap-input" value="{{union.lastName}}">
  </div>
</div>